import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';
import ServicesPage from '@/pages/services/page';
import ProjectsPage from '@/pages/projects/page';
import ProjectDetailPage from '@/pages/project-detail/page';
import ContactPage from '@/pages/contact/page';

const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/projects', element: <ProjectsPage /> },
  { path: '/projects/:slug', element: <ProjectDetailPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;